<template>
    <div>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="userName" label="收款联系人姓名:" :rules="[{required: true, message: '请输入收款联系人姓名'}]">    
                        <el-input v-model.trim="formData.userName" size="medium" maxlength="10" placeholder="请输入收款联系人姓名"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="userTelephone" label="收款联系人手机:" :rules="[{required: true, message: '请输入收款联系人手机'},{ validator: this.$utils.validatePhone }]">    
                        <el-input v-model.trim="formData.userTelephone" size="medium" placeholder="请输入收款联系人手机"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="userEmail" label="收款联系人邮箱:" :rules="[{required: true, message: '请输入收款联系人邮箱'},{ type: 'email', message: '请输入正确的邮箱地址' }]">    
                        <el-input v-model.trim="formData.userEmail" size="medium" maxlength="100" placeholder="请输入收款联系人邮箱"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="address" label="通讯地址:" :rules="[{required: true, message: '请输入通讯地址'}]">    
                        <el-input v-model.trim="formData.address" size="medium" maxlength="100" placeholder="请输入通讯地址"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
		<el-row :gutter="24" class="MT20">
			<el-col :xs="24" :sm="12" :xl="8">
				<el-form-item prop="bankType">
					<span slot="label">银行地区选择：</span>
				    <el-select v-model="formData.bankType" size="medium" @change="changeBanktype()">
				        <el-option :value="0" label="中国大陆"></el-option>
						<el-option :value="1" label="中国大陆以外"></el-option>
				    </el-select>
				</el-form-item>
			</el-col>
		</el-row>
        <el-row :gutter="30" v-if="formData.bankType == 0">            
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="bankCardId" label="银行卡号:" :rules="[{required: true, message: '请输入银行卡号'}]">    
                    <el-input v-model.trim="formData.bankCardId" @blur="formData.bankCardId = formData.bankCardId.replaceAll(' ','')" size="medium" maxlength="100" placeholder="请输入银行卡号"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="bankAddress" :rules="[{required: true, message: '请输入开户网点'}]">    
                    <span slot="label">开户网点: <small><div class="color-danger">开户网点即支行名称，请准确选择，否则可能影响结款</div></small></span>
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-cascader
                                ref="cityCascader"
                                v-model="city"
                                :options="cityList"
                                filterable
                                :props="{label:'name',children:'cityList',value:'id'}"
                                size="medium"
								clearable
								@change="onCityChange"
                                placeholder="省份/城市">
                            </el-cascader>
                        </el-col>
                        <el-col :span="16">
                            <!-- <el-input v-model.trim="formData.bankAddress" size="medium" maxlength="100" placeholder="输入关键字查询支行"></el-input> -->
                            <el-select
                                v-model="formData.bankAddress"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="输入关键字查询支行"
                                :remote-method="remoteBankAddress"
                                :loading="bankLoading"
                                size="medium"
                                @change="bankAddressChange"
                                @focus="remoteBankAddress()"
                                clearable>
                                <el-option
                                    v-for="(item,index) in bankAddressObj && bankAddressObj.record"
                                    :key="index"
                                    :label="item.lname"
                                    :value="item.lname">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-col>
        </el-row>
		<el-row :gutter="24" class="MT20" v-if="formData.bankType == 1" >
			<el-col :xs="24" :sm="12" :xl="8">
			    <el-form-item prop="bankAddress" label="开户网点/银行名称:" :rules="[{required: true, message: '请输入完整的银行名称'}]">    
			        <el-input v-model.trim="formData.bankAddress" size="medium" maxlength="100" placeholder="请输入完整的银行名称"></el-input>
			    </el-form-item>
			</el-col>
			<el-col :xs="24" :sm="12" :xl="8">
			    <el-form-item prop="bankCardId" label="银行卡号:" :rules="[{required: true, message: '请输入收款银行代码SWIFT'}]">    
			        <el-input v-model.trim="formData.bankCardId" @blur="formData.bankCardId = formData.bankCardId.replaceAll(' ','')" size="medium" maxlength="100" :placeholder="formData.bankType == 0 ? '请输入银行卡号' :'请输入收款银行代码SWIFT'"></el-input>
			    </el-form-item>
			</el-col>
		</el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="bankAccount" label="银行账户名:" :rules="[{required: true, message: '请输入银行账户名'}]">    
                    <el-input v-model.trim="formData.bankAccount" size="medium" maxlength="100" placeholder="请输入银行账户名"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="accountType" label="账户性质:">
                    <el-select v-model="formData.accountType" size="medium" :disabled="accountTypeDisable">
                        <el-option :value="1" label="企业"></el-option>
                        <!-- <el-option :value="2" label="个人"></el-option>    21372453 -->
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
    </div>
</template>

<script>
// import {fetchBank} from '@/assets/js/commonApi';
import {fetchAllCity} from '@/assets/js/commonApi'
export default {
    props:{
        formData:{
            type: Object,
            default: null
        },
        accountTypeDisable:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            // bankList:[],
            cityList: [],
            keyword: "",
            city: [],
            bankLoading: false,
            bankAddressObj: null
        }
    },
    created(){
        // this.getBankList();
        this.getCityList();
    },
    watch:{
        'formData.id'(){
            if( this.formData.bankProvinceCode && this.formData.bankCityCode ){
                this.city = [Number( this.formData.bankProvinceCode ) , Number( this.formData.bankCityCode )]
            }
        }
    },
    methods:{
        //获取所有银行
        // getBankList(){
        //     fetchBank().then(res => {
        //         const {state, result} = res.data;
        //         if(state == 1){
        //             this.bankList = result;
        //         }
        //     })
        // },
		changeBanktype(){
			this.formData.bankAddress = ''
			this.formData.bankCardId = ''
		},
        //获取所有城市
        async getCityList(){
            const res = await fetchAllCity({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.cityList = result;
            }
        },
		onCityChange() {
		    if (this.city && this.city.length === 2) {
		      this.bankAddressObj = null;
		      this.formData.bankAddress = '';
		      this.remoteBankAddress('');
		    }
		  },
        remoteBankAddress(query){
            const _nodes = this.$refs.cityCascader.getCheckedNodes()
            const _pathLabels = _nodes && _nodes.length > 0 && _nodes[0] ? _nodes[0].pathLabels : [];

            if( !query && this.bankAddressObj ) return;
            this.bankLoading = true;
            this.$request({
                url: "/common/getBankLName",
                params: {
                    bankCard: this.formData.bankCardId,
                    province: _pathLabels.length  > 0 ? _pathLabels[0] : "",
                    city: _pathLabels.length  > 1 ? _pathLabels[1] : "",
                    keyword: query || ""
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 ) {
                        if( result.record ){
                            this.bankAddressObj = result
                        }else{
                            this.bankAddressObj.record = []
                        }
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                        this.bankAddressObj.record = []
                    }
                })
                // .catch(() => {
                //     this.$message.error("操作失败,请重试");
                // })
                .finally(() => {
                    this.bankLoading = false;
                });
        },
        //选择支行
        bankAddressChange(e){
        	if( this.formData.bankType == 0 ){
        		this.formData.bankId = this.bankAddressObj && this.bankAddressObj.bankId ? this.bankAddressObj.bankId : '';
        		const _o = this.bankAddressObj && this.bankAddressObj.record.find(v => v.lname == e);
        		this.formData.bankName = _o && _o.bank ? _o.bank : "";
        		this.formData.bankCityCode = _o && _o.cityCode ? _o.cityCode : "";
        		this.formData.bankProvinceCode = _o && _o.provinceCode ? _o.provinceCode : "";
        		if( _o && _o.cityCode && _o.provinceCode ){
        			this.city = [Number( _o.provinceCode ) , Number( _o.cityCode )]
        			this.formData.bankCityCode = _o.cityCode
        		}else{					
        			const province = this.cityList.find(item => item.id == this.formData.bankProvinceCode )					
        			this.city = [Number( this.formData.bankProvinceCode ) , Number( province && province.cityList[0].code)]
        			this.formData.bankCityCode = province && province.cityList[0].code
        		}
        	}            
        },
    }
}
</script>